import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "antd";
import { useTranslation } from "react-i18next";

import DateEditor from "@tailormed/common-client/component/inline-edit/editors/DateEditor";

const EnrollmentApprovedDateInlineEditor = ({
  value,
  effectiveIndefinitely: initialEffectiveIndefinitely = false,
  onCommit,
  onCancel,
  autoFocus = true,
  placeholder
}) => {
  const { t } = useTranslation();
  const [isIndefinite, setIsIndefinite] = useState(Boolean(initialEffectiveIndefinitely));
  const isIndefiniteRef = useRef(isIndefinite);

  useEffect(() => {
    isIndefiniteRef.current = isIndefinite;
  }, [isIndefinite]);

  const handleDateCommit = (newDate) => {
    if (typeof onCommit !== "function") return;
    if (isIndefiniteRef.current) {
      onCommit({ approvedDate: newDate, effectiveIndefinitely: true, validThrough: null });
      return;
    }
    onCommit({ approvedDate: newDate, effectiveIndefinitely: false });
  };

  const handleCheckboxChange = (event) => {
    setIsIndefinite(event.target.checked);
  };

  const checkbox = (
    <Checkbox checked={isIndefinite} onChange={handleCheckboxChange} onMouseDown={(e) => e.preventDefault()}>
      <span style={{ fontWeight: 600 }}>{t("patientApplications.valid_indefinitely")}</span>
    </Checkbox>
  );

  return (
    <DateEditor
      autoFocus={autoFocus}
      value={value}
      placeholder={placeholder}
      onCommit={handleDateCommit}
      onCancel={onCancel}
      secondaryControl={checkbox}
    />
  );
};

EnrollmentApprovedDateInlineEditor.propTypes = {
  value: PropTypes.any,
  effectiveIndefinitely: PropTypes.bool,
  onCommit: PropTypes.func,
  onCancel: PropTypes.func,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.node
};

export default EnrollmentApprovedDateInlineEditor;
